import './App.css';
import PathFinding from './components/PathFinding';


function App() {
  return (
    <div className="App">
      <PathFinding/>
    </div>
  );
}

export default App;
